export default [
  { text: "lecture.states.PLANNED", value: "PLANNED" },
  { text: "lecture.states.DOING", value: "DOING" },
  { text: "lecture.states.DONE", value: "DONE" },
  { text: "lecture.states.CANCELLED", value: "CANCELLED" },
];
